// extracted by mini-css-extract-plugin
export var disabled = "_rz-0";